"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBrowser;

/**
  * Check if we are running in a TRUE browser (i.e. **NOT** Node.js)
  * environment. This will only return true in REAL browser environments
  * (i.e. not `jsdom`). The navigator object will toString as '[object Navigator]'
  * instead of '[object Object]' if it was a leaked Node.js global.
  *
  * *NOTE:* This will return true in PhantomJS environments and other headless
  * browsers since those are, in fact, REAL browsers in the strict sense.
  *
  * @returns {Boolean} Is this a browser
  * @public
  */
function isBrowser() {
  return typeof navigator !== 'undefined' && Object.prototype.toString.call(navigator) === '[object Navigator]';
}